//many products in cart make cart longer than height of window - bugfix

const myTimeout = setTimeout(cartHeight, 2500);

function cartHeight(){
let winHi = window.innerHeight;
let cart = window.document.querySelectorAll(".mini-cart-products__container")[0];
cart.style.maxHeight = winHi - 300 + "px";
//console.log('setHeight working');
}

const clicky = () => {
  //console.log('clicked');
  cartHeight();
}
let cartIcon = window.document.querySelector(".cart");
cartIcon.addEventListener("click", clicky);